import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListAIInferenceStreamsMetadataVariables = Types.Exact<{
  input: Types.AIInferenceStreamsMetadataInput;
}>;

export type ListAIInferenceStreamsMetadata = {
  aiInferenceStreamsMetadata: {
    edges: Array<{
      node: Pick<
        Types.AIInferenceStream,
        | 'alias'
        | 'streamName'
        | 'streamId'
        | 'pinned'
        | 'private'
        | 'saved'
        | 'parentStreamId'
        | 'createdAt'
        | 'userPrompt'
      > & {
        createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser>;
        usage?: Types.Maybe<
          Pick<
            Types.AIInferenceStreamUsage,
            | 'cacheCreationInputTokens'
            | 'cacheReadInputTokens'
            | 'inputTokens'
            | 'modelID'
            | 'outputTokens'
          >
        >;
      };
    }>;
    pageInfo: Pick<
      Types.CursorBasedPaginationPageInfo,
      'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'
    >;
  };
};

export const ListAIInferenceStreamsMetadataDocument = gql`
  query ListAIInferenceStreamsMetadata($input: AIInferenceStreamsMetadataInput!) {
    aiInferenceStreamsMetadata(input: $input) {
      edges {
        node {
          alias
          streamName
          streamId
          pinned
          private
          saved
          parentStreamId
          createdBy {
            ...ActorTeaser
          }
          createdAt
          userPrompt
          usage {
            cacheCreationInputTokens
            cacheReadInputTokens
            inputTokens
            modelID
            outputTokens
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ${ActorTeaser}
`;

/**
 * __useListAIInferenceStreamsMetadata__
 *
 * To run a query within a React component, call `useListAIInferenceStreamsMetadata` and pass it any options that fit your needs.
 * When your component renders, `useListAIInferenceStreamsMetadata` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAIInferenceStreamsMetadata({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListAIInferenceStreamsMetadata(
  baseOptions: Apollo.QueryHookOptions<
    ListAIInferenceStreamsMetadata,
    ListAIInferenceStreamsMetadataVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListAIInferenceStreamsMetadata, ListAIInferenceStreamsMetadataVariables>(
    ListAIInferenceStreamsMetadataDocument,
    options,
  );
}
export function useListAIInferenceStreamsMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListAIInferenceStreamsMetadata,
    ListAIInferenceStreamsMetadataVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListAIInferenceStreamsMetadata,
    ListAIInferenceStreamsMetadataVariables
  >(ListAIInferenceStreamsMetadataDocument, options);
}
export function useListAIInferenceStreamsMetadataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListAIInferenceStreamsMetadata,
    ListAIInferenceStreamsMetadataVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListAIInferenceStreamsMetadata,
    ListAIInferenceStreamsMetadataVariables
  >(ListAIInferenceStreamsMetadataDocument, options);
}
export type ListAIInferenceStreamsMetadataHookResult = ReturnType<
  typeof useListAIInferenceStreamsMetadata
>;
export type ListAIInferenceStreamsMetadataLazyQueryHookResult = ReturnType<
  typeof useListAIInferenceStreamsMetadataLazyQuery
>;
export type ListAIInferenceStreamsMetadataSuspenseQueryHookResult = ReturnType<
  typeof useListAIInferenceStreamsMetadataSuspenseQuery
>;
export type ListAIInferenceStreamsMetadataQueryResult = Apollo.QueryResult<
  ListAIInferenceStreamsMetadata,
  ListAIInferenceStreamsMetadataVariables
>;
export function mockListAIInferenceStreamsMetadata({
  data,
  variables,
  errors,
}: {
  data: ListAIInferenceStreamsMetadata;
  variables?: ListAIInferenceStreamsMetadataVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: ListAIInferenceStreamsMetadataDocument, variables },
    result: { data, errors },
  };
}
